module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-feedback"
  }, [_c('b-collapse', {
    staticClass: "panel is-danger",
    attrs: {
      "open": _vm.open
    },
    on: {
      "update:open": function($event) {
        _vm.open = $event
      }
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Ton avis compte")]), _vm._v(" "), _c('b-icon', {
    staticClass: "is-pulled-right",
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-content pannel-block"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('a', {
    staticClass: "app-feedback_issue",
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/forms/d/e/1FAIpQLSfzWiWdxqYwLWNlfTOQYfI2SovZM1mNQK0wKmPC9nc5LXLZ0Q/viewform"
    }
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('h4', {
    staticClass: "title is-6"
  }, [_vm._v("J'ai rencontré un problème")]), _vm._v(" "), _c('p', [_vm._v("Tu as rencontré un souci sur The Warmup ? Dis-nous tout !")])])]), _vm._v(" "), _c('a', {
    staticClass: "app-feedback_feature",
    attrs: {
      "target": "_blank",
      "href": "https://docs.google.com/forms/d/e/1FAIpQLSfbqzi1Gk_5F22FGs9Ot7aagIvEVc1OXt3kCyHm1-wl0cZBPQ/viewform"
    }
  }, [_c('div', {
    staticClass: "notification"
  }, [_c('h4', {
    staticClass: "title is-6"
  }, [_vm._v("J'ai un feedback")]), _vm._v(" "), _c('p', [_vm._v("Tu as une fonctionnalité ou une amélioration à proposer ? Vas-y")])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b356d92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFeedback.vue
// module id = 362
// module chunks = 9